<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('vehicle_registration.demand_notice')}}
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link to="/vehicle-registration">
                                        {{ trans('vehicle_registration.vehicle_registration') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ trans('payment.payment') }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" @click="$router.push('/vehicle-registration')"><i class="feather icon-list"></i> {{trans('vehicle_registration.demand_notice_list')}}</button>
                    
                </div>
            </div>

        </div>

        <div class="content-body">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{trans('vehicle_registration.vehicle_registration')}} {{ trans('payment.payment') }}</h4>
                </div>

                <div class="card-content">
                    <div class="card-body">
                        <form @submit.prevent="proceed" @keydown="vehicleForm.errors.clear($event.target.name)">
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="">{{trans('tax_payer.tax_id')}}</label>
                                        <input class="form-control" :class="{ 'is-invalid': vehicleForm.errors.has('tax_id') }" type="text" value="" v-model="vehicleForm.tax_id" name="tax_id" :placeholder="trans('tax_payer.tax_id')" disabled>
                                        <show-error :form-name="vehicleForm" prop-name="tax_id"></show-error>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="">{{trans('user.name')}}</label>
                                        <input class="form-control" :class="{ 'is-invalid': vehicleForm.errors.has('name') }" type="text" value="" v-model="vehicleForm.name" name="name" :placeholder="trans('user.name')" disabled>
                                        <show-error :form-name="vehicleForm" prop-name="name"></show-error>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="">{{trans('user.phone')}}</label>
                                        <input class="form-control" :class="{ 'is-invalid': vehicleForm.errors.has('phone') }" type="text" value="" v-model="vehicleForm.phone" name="phone" :placeholder="trans('user.phone')" disabled>
                                        <show-error :form-name="vehicleForm" prop-name="phone"></show-error>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="">{{trans('user.email')}}</label>
                                        <input class="form-control" :class="{ 'is-invalid': vehicleForm.errors.has('email') }" type="text" value="" v-model="vehicleForm.email" name="email" :placeholder="trans('user.email')" disabled>
                                        <show-error :form-name="vehicleForm" prop-name="email"></show-error>
                                    </div>
                                </div>
                                
                                <div class="col-xl-12 col-md-12 col-12">
                                    <table class="table table-sm">
                                        <thead class="thead-light">
                                            <tr>
                                                <th width="5%">S/N</th>
                                                <th width="55%">Item</th>
                                                <th width="20%">Amount</th>
                                                <th width="20%">Select</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in payItems" :key="item.id">
                                                <td>{{ index + 1 }}</td>
                                                <td>
                                                    <label class="form-check-label" :for="'pay_item_'+item.id">
                                                        {{ item.name }}
                                                    </label>
                                                </td>
                                                <td>{{ item.amount | formatMoney }}</td>
                                                <td>
                                                    <div class="form-check">
                                                        <input 
                                                            type="checkbox" 
                                                            class="form-check-input" 
                                                            :id="'pay_item_'+item.id"
                                                            v-model="selectedItems"
                                                            :value="item.id"
                                                            @change="updateTotal"
                                                            :disabled="item.name.toLowerCase() === 'sms' || item.name.toLowerCase() === 'transaction charges'"
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot v-if="payItems.length > 0">
                                            <tr>
                                                <td colspan="2" class="text-right"><strong>Total Amount:</strong></td>
                                                <td><strong>{{ totalAmount | formatMoney }}</strong>
                                                    <span v-if="vehicleForm.errors.has('amount')" class="text-danger">
                                                        <br>
                                                    {{ vehicleForm.errors.get('amount') }}
                                                    </span>
                                                </td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                
                                            
                            </div>
                            <div class="row">
                                <div class="col-xl-6 col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="">{{trans('user.tax_office_id')}}</label>
                                        <select class="form-control" :class="{ 'is-invalid': vehicleForm.errors.has('tax_office_id') }" name="tax_office_id" v-model="vehicleForm.tax_office_id">
                                            <option value="">Select Tax Office</option>
                                            <option v-for="(name, id) in taxOffices" :value="id">{{ name }}</option>
                                        </select>
                                        <show-error :form-name="vehicleForm" prop-name="tax_office_id"></show-error>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-md-6 col-6">
                                    <div class="form-group">
                                        <label for="">{{trans('payment.gateway_id')}}</label>
                                        <select class="form-control" :class="{ 'is-invalid': vehicleForm.errors.has('gateway_id') }" name="gateway_id" v-model="vehicleForm.gateway_id" placeholder="Select Payment 
                                        Gateway">
                                            <option value="">Select Payment Channel</option>
                                            <option v-for="(name, id) in gateways" :value="id">{{ name }}</option>
                                        </select>
                                        <show-error :form-name="vehicleForm" prop-name="gateway_id"></show-error>
                                    </div>
                                </div>
                                <div class="col-md-8 offset-md-4">
                                    <button-spinner
                                        :is-loading="vehicleForm.isLoading" 
                                        :disabled="vehicleForm.isLoading"
                                        
                                        class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right"
                                        style="height: 39px; color: #fff;"
                                        >
                                        <span v-if="id">{{trans('general.update')}}</span>
                                        <span v-else>{{trans('general.save')}}</span>
                                    </button-spinner>

                                    <router-link to="/vehicle-registration" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1">{{trans('general.cancel')}}
                                    </router-link>

                                </div>
                            </div>
                        </form>

                        <div class="modal fade" id="confirmPayment" tabindex="-1" role="dialog" aria-labelledby="paymentDetail" aria-hidden="true" style="display: none;">
                            <div class="modal-dialog modal-lg">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h4 class="modal-title" id="paymentDetail">Demand Notice Created</h4>
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    </div>
                                    <div class="modal-body" v-if="showConfirm">
                                         <h4>Confirm Payment</h4>
                                        <p>Transaction Reference: <strong>{{ reference }}</strong></p>
                                        <p>TAX ID: <strong>{{ vehicleForm.tax_id }}</strong></p>
                                        <p>Phone NO: <strong>{{ vehicleForm.phone }}</strong></p>
                                        <p>Email: <strong>{{ vehicleForm.email }}</strong></p>
                                        <p>Year: <strong>{{ vehicleForm.payment_year }}</strong></p>
                                        <table class="table">
                                            <tr>
                                                <th>Item</th>
                                                <th>Amount</th>
                                                <th>Description</th>
                                            </tr>
                                            <tr v-for="item in payment_items">
                                                <td>{{ item.pay_item.name }}</td>
                                                <td>{{ item.amount }}</td>
                                                <td>{{ item.description }}</td>
                                            </tr>
                                        </table>
                                        <p>Total Amount: <strong>{{ vehicleForm.amount }}</strong></p>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-danger waves-effect text-left" data-dismiss="modal">{{trans('general.close')}}</button>
                                        <button v-if="vehicleForm.gateway_id == 1" type="button" class="btn btn-primary waves-effect" @click="generateRRR">Generate RRR</button>
                                        <button v-if="vehicleForm.gateway_id == 3" type="button" class="btn btn-primary waves-effect" @click="showCheckoutForm">Pay Now</button>
                                        <button v-if="vehicleForm.gateway_id != 3" type="button" class="btn btn-primary waves-effect" @click="confirmPayment">Confirm</button>
                                        <button type="button" class="btn btn-info waves-effect" @click="printInvoice">Print</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                vehicleForm: new Form({
                    isLoading: false,
                    vehicle_registration_id: this.$route.params.id,
                    user_id: '',
                    tax_id: '',
                    name: '',
                    phone: '',
                    email: '',
                    amount: '',
                    payment_year: new Date().getFullYear(),
                    tax_office_id: 2,
                    gateway_id: '',
                    pay_items: []
                }),
                showConfirm: false,
                payment_items: '',
                reference: '',
                tax_id: '',
                payItems: [],
                taxOffices: [],
                gateways: [],
                selectedItems: [],
                totalAmount: 0,
                rrr: '',
                bank_name: '',
                bank_account_number: '',
                checkout_url: '',
            };
        },
        props: ['id'],
        mounted() {
            this.fetchPreRequisites();
            this.fetchRegistration();
        },
        filters: {
          formatMoney(value){
            return helper.formatMoney(value);
          }
        },
        methods: {
            fetchPreRequisites(){
                axios.get('/api/user/pre-requisite?fetch_tax_payers=false&category=3&vehicle_registration_id=' + this.vehicleForm.vehicle_registration_id)
                    .then(response => response.data)
                    .then(response => {
                        this.payItems = response.payItems;
                        this.taxOffices = response.taxOffices;
                        this.gateways = response.gateways;
                        this.selectedItems = [];
                        this.totalAmount = 0;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error)
                    });
            },
            fetchRegistration(){
                axios.get('/api/vehicle-registration/'+this.vehicleForm.vehicle_registration_id)
                    .then(response => response.data)
                    .then(response => {
                        this.vehicleForm.user_id = response.user_id;
                        this.vehicleForm.tax_id = response.user.tax_id;
                        this.vehicleForm.name = response.user.name;
                        this.vehicleForm.email = response.user.email;
                        this.vehicleForm.phone = response.user.phone;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/vehicle-registration');
                    });
            },
            proceed(){
                if(this.id)
                    this.updatePayment();
                else
                    this.storePayment();
            },
            storePayment(){
                this.vehicleForm.isLoading = true;
                this.vehicleForm.post('/api/vehicle-registration/payment')
                    .then(response => {
                        this.reference = response.reference;
                        this.vehicleForm.vehicle_registration_id = this.vehicleForm.id;
                        this.vehicleForm.tax_id = response.user.tax_id;
                        this.vehicleForm.phone = response.user.phone;
                        this.vehicleForm.email = response.user.email;
                        this.vehicleForm.pay_items = response.payment_items;
                        this.payment_items = response.payment_items;
                        this.vehicleForm.amount = response.amount;
                        this.vehicleForm.payment_year = response.payment_year;
                        this.vehicleForm.gateway_id = response.gateway_id;
                        this.rrr = response.rrr;
                        this.bank_name = response.bank_name;
                        this.bank_account_number = response.account_number;
                        this.checkout_url = response.checkout_url;
                        this.vehicleForm.isLoading = false;
                        this.showConfirm = true;
                        $('#confirmPayment').modal('show');
                        
                    })
                    .catch(error => {
                        this.vehicleForm.isLoading = false;
                        toastr.error(error.message);
                        helper.showErrorMsg(error);
                    });
            },
            generateRRR(){
                $('#confirmPayment').modal('hide');
                window.open('https://login.remita.net/remita/exapp/api/v1/send/api/print/billsvc/biller/' + this.rrr + '/printinvoiceRequest.pdf');
            },
            confirmPayment(){
                $('#confirmPayment').modal('hide');
                if (this.vehicleForm.gateway_id == 1) {
                    this.makeRemitaPayment(this.rrr);
                } else if(this.vehicleForm.gateway_id == 3){
                    window.location.href = this.checkout_url;
                } else {
                    window.location.href = '/payment/' + this.reference + '/print';
                }
            },
            showCheckoutForm(){
                $('#confirmPayment').modal('hide');
                setTimeout(() => {
                    window.location.href = this.checkout_url;
                }, 2000);
                // this.showCheckout = true;
                // $('#checkoutPayment').modal('show');
            },
            printInvoice(){
                $('#confirmPayment').modal('hide');
                window.location.href = '/payment/' + this.reference + '/print';
            },
            makeRemitaPayment(rrr) {
                var randomnumber = Math.floor(Math.random());
                var paymentEngine = RmPaymentEngine.init({
                    key: "QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY",
                    merchantName: "Sokoto Internal Revenue Services",
                    processRrr: true,
                    transactionId: randomnumber,
                    channel: "CARD,USSD,TRANSFER,BANK,BRANCH,IBANK",
                    extendedData: { 
                        customFields: [ 
                            { 
                                name: "rrr", 
                                value: rrr
                            } 
                        ]
                    },
                    
                    onSuccess: function (response) {
                        axios.get('/api/payment/verify/?rrr=' + rrr)
                            .then(response => response.data)
                            .then(response => {
                                if (response.data.message == "Successful") {
                                    toastr.success('Payment successful.');
                                    //this.$router.push('/payment/' + response.data.orderId);
                                    window.location.href = '/payment/' + response.data.orderId + '/print';
                                } else {
                                    toastr.error('There is an error.');
                                }
                            })
                            .catch(error => {
                                helper.showDataErrorMsg(error)
                            });
                    },
                    onError: function (response) {
                        toastr.error(response);
                        console.log('callback Error Response', response);
                    },
                    onClose: function () {
                        console.log("closed");
                    }
                });
                    paymentEngine.showPaymentWidget();
            },
            closeModal(){
                this.clearFormData();
            },
            updateTotal() {
                // Calculate total from selected items
                this.totalAmount = this.payItems
                    .filter(item => this.selectedItems.includes(item.id))
                    .reduce((sum, item) => sum + parseFloat(item.amount), 0);
                    
                // Update vehicleForm amount
                this.vehicleForm.amount = this.totalAmount;
                
                // Update vehicleForm pay_items
                this.vehicleForm.pay_items = this.payItems
                    .filter(item => this.selectedItems.includes(item.id))
                    .map(item => ({
                        pay_item_id: item.id,
                        amount: item.amount,
                        description: item.name,
                        month_from: '',
                        month_to: ''
                    }));
            }
        },
        watch: {
            payItems: {
                handler(newItems) {
                newItems.forEach(item => {
                    this.selectedItems.push(item.id);
                });

                // Call updateTotal manually
                this.updateTotal();
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>
